module.exports = __webpack_public_path__ + "static/media/0024_TRAD_LES_MURS_PALOMINO_W_VPL2100.2652a7eb.webp";